"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrderAccountInstruction = exports.getTokenAccount = exports.getOrderSide = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const data_source_1 = require("@staratlas/data-source");
const state_1 = require("./state");
const getOrderSide = (orderAccount) => {
    if (JSON.stringify(orderAccount.data.orderSide) === JSON.stringify({ buy: {} })) {
        return 'BuySide';
    }
    return 'SellSide';
};
exports.getOrderSide = getOrderSide;
/**
 * Get or create a token account
 * @param connection - Solana connection object
 * @param wallet - the owner of the token account
 * @param mint - the mint
 * @param newAccountFunder - the payer of the rent for new account if a new account is to be created
 * @param amountNeededHeuristic - amount needed heuristic. Used to select the minimum acceptable balance in case the wallet has more than one token account
 * @returns the token account address
 */
function getTokenAccount(connection, wallet, mint, newAccountFunder = wallet, amountNeededHeuristic) {
    return __awaiter(this, void 0, void 0, function* () {
        // Get all parsed token accounts for a given owner and mint
        const { value: tokenAccounts } = yield connection.getParsedTokenAccountsByOwner(wallet, { mint });
        let tokenAccount = null;
        if (amountNeededHeuristic === undefined) {
            let maxTokens = null;
            for (const account of tokenAccounts) {
                if (account.account.data.parsed.type === 'account') {
                    const parsedAccount = account.account.data.parsed;
                    const tokenAmount = new anchor_1.BN(parsedAccount.info.tokenAmount.amount);
                    if (maxTokens === null || tokenAmount.gt(maxTokens)) {
                        tokenAccount = account.pubkey;
                        maxTokens = tokenAmount;
                    }
                }
            }
        }
        else {
            let minTokens = null;
            for (const account of tokenAccounts) {
                if (account.account.data.parsed.type === 'account') {
                    const parsedAccount = account.account.data.parsed;
                    const tokenAmount = new anchor_1.BN(parsedAccount.info.tokenAmount.amount);
                    if (tokenAmount.gt(new anchor_1.BN(amountNeededHeuristic)) &&
                        (minTokens === null || tokenAmount.lt(minTokens))) {
                        tokenAccount = account.pubkey;
                        minTokens = tokenAmount;
                    }
                }
            }
        }
        if (tokenAccount === null) {
            const associatedTokenAddress = yield getAssociatedTokenAddress(wallet, mint);
            const { value: account } = yield connection.getParsedAccountInfo(associatedTokenAddress, 'confirmed');
            if (account === null || account.owner.equals(web3_js_1.SystemProgram.programId)) {
                return {
                    tokenAccount: associatedTokenAddress,
                    createInstruction: () => Promise.resolve({
                        instruction: (0, spl_token_1.createAssociatedTokenAccountInstruction)(newAccountFunder, associatedTokenAddress, wallet, mint, spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID),
                        signers: [],
                    }),
                };
            }
            if ('program' in account.data &&
                account.data.parsed.type === 'account' &&
                new web3_js_1.PublicKey(account.data.parsed.info.owner).equals(wallet)) {
                return {
                    tokenAccount: associatedTokenAddress,
                };
            }
            else {
                const newTokenAccount = web3_js_1.Keypair.generate();
                return {
                    tokenAccount: newTokenAccount,
                    createInstruction: () => Promise.resolve({
                        instruction: (0, spl_token_1.createInitializeAccountInstruction)(newTokenAccount.publicKey, mint, wallet, spl_token_1.TOKEN_PROGRAM_ID),
                        signers: [(0, data_source_1.keypairToAsyncSigner)(newTokenAccount)],
                    }),
                };
            }
        }
        else {
            return {
                tokenAccount,
            };
        }
    });
}
exports.getTokenAccount = getTokenAccount;
/**
 * Get Associated Token Address
 * @param owner - the owner of the token account
 * @param mint - the mint
 * @returns the token account address
 */
function getAssociatedTokenAddress(owner, mint) {
    return __awaiter(this, void 0, void 0, function* () {
        const [address] = yield web3_js_1.PublicKey.findProgramAddress([owner.toBuffer(), spl_token_1.TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()], spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID);
        return address;
    });
}
/**
 * Create a new empty order account
 * @param connection - Solana connection object
 * @param program - GalacticMarketplace Program
 * @param orderAccount - the order account address Keypair
 * @returns a promise of InstructionReturn
 */
function createOrderAccountInstruction(connection, program, orderAccount) {
    return Promise.resolve((funder) => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: web3_js_1.SystemProgram.createAccount({
                fromPubkey: funder.publicKey(),
                newAccountPubkey: orderAccount.publicKey,
                space: state_1.Order.MIN_DATA_SIZE,
                lamports: yield connection.getMinimumBalanceForRentExemption(state_1.Order.MIN_DATA_SIZE),
                programId: program.programId,
            }),
            signers: [(0, data_source_1.keypairToAsyncSigner)(orderAccount)],
        });
    }));
}
exports.createOrderAccountInstruction = createOrderAccountInstruction;
//# sourceMappingURL=util.js.map